import React, { useEffect, useRef, useState } from "react";
import { useIntercom } from "react-use-intercom";
import { Loading } from "go-core/components/Loading";

const OrganizationChatPage = () => {
	const [intercomPresent, setIntercomPresent] = useState(false);
	const [loading, setLoading] = useState(true);
	const presenceTimeout = useRef<number>(0);
	const stylesTimeout = useRef<number>(0);
	const { show } = useIntercom();

	useEffect(() => {
		checkForIntercomPresence();

		return () => {
			clearTimeout(presenceTimeout.current);
		};
	}, []);

	useEffect(() => {
		if (intercomPresent) {
			show();
			updateIntercomStyles();
		}
	}, [intercomPresent, loading]);

	const checkForIntercomPresence = () => {
		clearTimeout(presenceTimeout.current);

		if (intercomPresent) return;

		const intercomIframe = document.getElementById("intercom-frame");

		if (!intercomIframe) {
			presenceTimeout.current = window.setTimeout(() => {
				checkForIntercomPresence();
			}, 500);
		} else {
			setIntercomPresent(true);
		}
	};

	const updateIntercomStyles = () => {
		clearTimeout(stylesTimeout.current);

		if (!loading) return;

		const intercomContainer = document
			.getElementById("intercom-container")
			?.querySelector(".intercom-app")
			?.querySelector(".intercom-messenger-frame");
		const intercomInnerIframe = intercomContainer?.querySelector("iframe");
		const intercomLauncherFrame = document.querySelector(".intercom-launcher-frame") as HTMLElement;

		if (intercomLauncherFrame) {
			intercomLauncherFrame.style.display = "none";
		}

		if (intercomInnerIframe) {
			intercomInnerIframe.style.position = "fixed";
			intercomInnerIframe.style.top = "0";
			intercomInnerIframe.style.left = "0";
			setLoading(false);
		}

		stylesTimeout.current = window.setTimeout(() => {
			updateIntercomStyles();
		}, 500);
	};

	return (
		<div className="chat-page" style={{ zIndex: loading ? 2147483647 : 1000 }}>
			{loading && <Loading />}
		</div>
	);
};

export default OrganizationChatPage;
